import { ChangeEvent, useState } from 'react'

import { useUpdateEffect } from 'ahooks'
import { Input, Space } from 'antd'
import { createStyles } from 'antd-style'

import { SendCodeResult } from '@eastcoal/api/nexus/interface'

import { SmsButton } from '../SmsButton'

import { SmsInputProps } from './interfact'

const useStyles = createStyles(({ prefixCls }) => ({
  smsInput: {
    width: '100%',
    [`& .${prefixCls}-space-item:first-child`]: {
      flex: 1
    }
  }
}))

export const SmsInput = ({
  allowSend,
  buttonType = 'default',
  value,
  onChange,
  /* -------------------------------------------------------------------------- */
  /*                                 Input Props                                */
  /* -------------------------------------------------------------------------- */
  allowClear,
  placeholder,

  /* -------------------------------------------------------------------------- */
  /*                               SmsButton Props                              */
  /* -------------------------------------------------------------------------- */
  api,
  requirePhone,
  phone,
  digit = 4,
  expire,
  templateCode,
  templateParam,
  comment,
  captchaEnabled,
  captchaSceneId
}: SmsInputProps) => {
  const [result, setResult] = useState<SendCodeResult>()

  const handleCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      code: e.target.value,
      ticketId: result?.ticketId
    })
  }

  const code = result?.code
  const ticketId = result?.ticketId

  useUpdateEffect(() => {
    // 测试环境下会返回模拟的验证码
    onChange?.({
      code,
      ticketId
    })
  }, [code, ticketId])

  const { styles } = useStyles()

  return (
    <Space className={styles.smsInput} orientation='horizontal'>
      <Input
        allowClear={allowClear}
        autoComplete='off'
        placeholder={placeholder ?? `${digit} 位数验证码`}
        value={value?.code}
        onChange={handleCodeChange}
      />
      <SmsButton
        api={api}
        captchaEnabled={captchaEnabled}
        captchaSceneId={captchaSceneId}
        comment={comment}
        digit={digit}
        disabled={allowSend === false}
        expire={expire}
        phone={phone}
        requirePhone={requirePhone}
        templateCode={templateCode}
        templateParam={templateParam}
        type={buttonType}
        onSuccess={setResult}
      />
    </Space>
  )
}
